import React, { useState, useEffect } from "react";
import AppsCategoriesBlock from "./AppsCategoriesBlock";
import DeviceAppsList from "./DeviceAppsList";
import { useSelector, useDispatch } from "react-redux";
import useAppMonitoring from "./useAppMonitoring";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules/setRulesAction";
import { blockAppLists } from "../../../AxiosRtk/AppActivity";

const AppsMonitoring = ({ deviceSelected, getLangTranslation }) => {
  const [appMonitoring, setAppMonitoring] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false); // Loading state for API

  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const [normalFormattedAllowedApps, setNormalFormattedAllowedApps] = useState(
    []
  );
  // console.log("normalFormattedAllowedApps", normalFormattedAllowedApps);



  const { setRulesData } = useSelector(({ setRules }) => setRules);

  const {
    getCollectionData,
    handleInputChange,
    handleAppCategoryChange,
    handleAllSelect,
    handleCategoryStatusChange,
  } = useAppMonitoring(deviceSelected, appMonitoring, setAppMonitoring);
  // console.log("appMonitoring", appMonitoring);


  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <DeviceAppsList
            deviceSelected={deviceSelected}
            getLangTranslation={getLangTranslation}
          />
        );
      case 1:
        return (
          <AppsCategoriesBlock
            deviceSelected={deviceSelected}
            appMonitoring={appMonitoring}
            setAppMonitoring={setAppMonitoring}
            handleAppCategoryChange={handleAppCategoryChange}
            handleAllSelect={handleAllSelect}
            handleCategoryStatusChange={handleCategoryStatusChange}
            getLangTranslation={getLangTranslation}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      dispatch(setRuleDataSetUp(null));
    }
  }, [deviceSelected, getCollectionData, dispatch]);

  useEffect(() => {
    if (setRulesData) {
      setAppMonitoring(setRulesData?.appsmonitoring);
    } else {
      setAppMonitoring(null);
    }
  }, [setRulesData]);

  useEffect(() => {
    setLoading(true); // Start loading
    blockAppLists({ deviceId: deviceSelected })
      .then((response) => {
        const blockedApps = response?.data?.result || []; // Extract blocked apps
        setNormalFormattedAllowedApps(blockedApps); // Update state with blocked apps
      })
      .catch((error) => {
        console.error("Error fetching blocked app list:", error);
      })
      .finally(() => {
        setLoading(false); // Stop loading after API call
      });
  }, [])

  if (!deviceSelected) {
    return (
      <div className="text-center my-3">
        -- {getLangTranslation("DEVICE_NOT_SELCTED", "Device not selected")} --
      </div>
    );
  }

  return (
    <>
      <div className="form-check form-switch mb-4">
        <input
          className="form-check-input"
          id="APP_MONITORING_ENABLE_APP_MONITORING"
          name="APP_MONITORING_ENABLE_APP_MONITORING"
          type="checkbox"
          role="switch"
          checked={appMonitoring?.appMonitoringEnabled || false}
          onChange={handleInputChange}
        />
        <label className="form-check-label" htmlFor="ALLOW_INSTALL_NEW_APP">
          <span className="text-dark fw-semibold">
            {getLangTranslation(
              "APP_MONITORING_ENABLE_APP_MONITORING",
              "Enable App Monitoring"
            )}
          </span>
        </label>
      </div>

      {/* {
        appMonitoring?.appMonitoringEnabled && (
          <>
            <div className="form-check form-switch mb-4">
              <input
                className="form-check-input"
                id="ALLOW_INSTALL_NEW_APP"
                name="ALLOW_INSTALL_NEW_APP"
                type="checkbox"
                role="switch"
                checked={appMonitoring?.installNewApps || 0}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="ALLOW_INSTALL_NEW_APP">
                <span className="text-dark fw-semibold">
                  {getLangTranslation(
                    "OVERLAY_SCREEN_INSTALLED_NEW_APP",
                    "Allow install new apps"
                  )}
                </span>
              </label>
            </div>
            <div className="form-check form-switch mb-4">
              <input
                className="form-check-input"
                id="STOP_APP_DELETION"
                name="STOP_APP_DELETION"
                type="checkbox"
                role="switch"
                checked={appMonitoring?.stopAppDeletion || 0}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="STOP_APP_DELETION">
                <span className="text-dark fw-semibold">
                  {getLangTranslation("APP_MONITORING_STOP_APP", "Stop app deletion")}
                </span>
              </label>
            </div>
            <div className="form-check form-switch mb-4">
              <input
                className="form-check-input"
                id="BLOCK_PRESELECTED_APP"
                name="BLOCK_PRESELECTED_APP"
                type="checkbox"
                role="switch"
                checked={appMonitoring?.blockOurPreselectedApp || 0}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="BLOCK_PRESELECTED_APP">
                <span className="text-dark fw-semibold">
                  {getLangTranslation(
                    "APP_MONITORING_BLOCK_OUR_PRESELECTED_APP",
                    "Block our selection of harmful apps"
                  )}
                  <span className="text-small text-gray mx-3 fw-normal">
                    {getLangTranslation(
                      "APP_MONITORING_THIS_OPTIONS_WILL_BLOCK_AUTOMATICALLY_ANY_AOO_WE_LISTED_INAPPROPRIATE",
                      "This options will block automatically any app we listed as inappropriate or dangerous for kids."
                    )}
                  </span>
                </span>
              </label>
            </div>
            <div
              className="card m-3 p-3 social-apps"
              style={{ maxHeight: "400px", overflowY: "auto" }} // Set fixed height and enable vertical scrolling
            >
              {normalFormattedAllowedApps
                ?.map((item, index) => {
                  // console.log("item",item);

                  return (
                    <div className="form-check form-switch form-check-right mb-4">
                      <label
                        className="form-check-label d-inline-flex align-items-center"
                        htmlFor={item?.AppPackageName}
                      >
                        <span className="icon-wrap icon-sm me-2 p-0">
                          <img src={item?.image} alt="avatar" />
                        </span>
                        {item?.appName}
                      </label>
                    </div>
                  );
                })}
            </div>
            <div className="form-check form-switch mb-9">
              <input
                className="form-check-input"
                id="AGE_RESTRICTION"
                name="AGE_RESTRICTION"
                type="checkbox"
                role="switch"
                checked={appMonitoring?.ageRestrictions || 0}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="AGE_RESTRICTION">
                <span className="text-dark fw-semibold">
                  {getLangTranslation(
                    "OVERLAY_SCREEN_AGE_RESTRICTIONS",
                    "Age restrictions"
                  )}
                  <span className="text-small text-gray mx-3 fw-normal">
                    {getLangTranslation(
                      "AGE_RESTRICTION_DESCRIPTION",
                      "This option will block your child from using apps for age > 12"
                    )}
                  </span>
                </span>
              </label>
            </div>
            <ul className="custom-tab-wrap">
              <li
                className={`custom-tab ${activeTab === 0 ? "active-tab" : ""}`}
                onClick={() => handleTabClick(0)}
              >
                {getLangTranslation("SETRULE_APP_MONITORING", "App monitoring")}
              </li>
              <li
                className={`custom-tab ${activeTab === 1 ? "active-tab" : ""}`}
                onClick={() => handleTabClick(1)}
              >
                {getLangTranslation(
                  "APP_MONITORING_APPS_CATEGORY_TAB_TITLE",
                  "Apps Categories"
                )}
              </li>
            </ul>
            {renderTabContent()}
          </>
        )
      } */}

      {appMonitoring?.appMonitoringEnabled && (
        <>
          {loading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>

              <div className="form-check form-switch mb-4">
                <input
                  className="form-check-input"
                  id="ALLOW_INSTALL_NEW_APP"
                  name="ALLOW_INSTALL_NEW_APP"
                  type="checkbox"
                  role="switch"
                  checked={appMonitoring?.installNewApps || 0}
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="ALLOW_INSTALL_NEW_APP">
                  <span className="text-dark fw-semibold">
                    {getLangTranslation(
                      "OVERLAY_SCREEN_INSTALLED_NEW_APP",
                      "Allow install new apps"
                    )}
                  </span>
                </label>
              </div>
              <div className="form-check form-switch mb-4">
                <input
                  className="form-check-input"
                  id="STOP_APP_DELETION"
                  name="STOP_APP_DELETION"
                  type="checkbox"
                  role="switch"
                  checked={appMonitoring?.stopAppDeletion || 0}
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="STOP_APP_DELETION">
                  <span className="text-dark fw-semibold">
                    {getLangTranslation("APP_MONITORING_STOP_APP", "Stop app deletion")}
                  </span>
                </label>
              </div>
              <div className="form-check form-switch mb-4">
                <input
                  className="form-check-input"
                  id="BLOCK_PRESELECTED_APP"
                  name="BLOCK_PRESELECTED_APP"
                  type="checkbox"
                  role="switch"
                  checked={appMonitoring?.blockOurPreselectedApp || 0}
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="BLOCK_PRESELECTED_APP">
                  <span className="text-dark fw-semibold">
                    {getLangTranslation(
                      "APP_MONITORING_BLOCK_OUR_PRESELECTED_APP",
                      "Block our selection of harmful apps"
                    )}
                    <span className="text-small text-gray mx-3 fw-normal">
                      {getLangTranslation(
                        "APP_MONITORING_THIS_OPTIONS_WILL_BLOCK_AUTOMATICALLY_ANY_AOO_WE_LISTED_INAPPROPRIATE",
                        "This options will block automatically any app we listed as inappropriate or dangerous for kids."
                      )}
                    </span>
                  </span>
                </label>
              </div>
              <div
                className="card m-3 p-3 social-apps"
                style={{ maxHeight: "400px", overflowY: "auto" }}
              >
                {normalFormattedAllowedApps.map((item, index) => (
                  <div
                    className="form-check form-switch form-check-right mb-4"
                    key={item.AppPackageName}
                  >
                    <label
                      className="form-check-label d-inline-flex align-items-center"
                      htmlFor={item.AppPackageName}
                    >
                      <span className="icon-wrap icon-sm me-2 p-0">
                        <img src={item.image} alt="avatar" />
                      </span>
                      {item.appName}
                    </label>
                  </div>
                ))}
              </div>
              <ul className="custom-tab-wrap">
                <li
                  className={`custom-tab ${activeTab === 0 ? "active-tab" : ""
                    }`}
                  onClick={() => handleTabClick(0)}
                >
                  {getLangTranslation("SETRULE_APP_MONITORING", "App monitoring")}
                </li>
                <li
                  className={`custom-tab ${activeTab === 1 ? "active-tab" : ""
                    }`}
                  onClick={() => handleTabClick(1)}
                >
                  {getLangTranslation(
                    "APP_MONITORING_APPS_CATEGORY_TAB_TITLE",
                    "Apps Categories"
                  )}
                </li>
              </ul>
              {renderTabContent()}
            </>
          )}
        </>
      )}

    </>
  );
};

export default AppsMonitoring;
